import { render, staticRenderFns } from "./CardConsumeList.vue?vue&type=template&id=0a3a5857"
import script from "./CardConsumeList.vue?vue&type=script&lang=js"
export * from "./CardConsumeList.vue?vue&type=script&lang=js"
import style0 from "./CardConsumeList.vue?vue&type=style&index=0&id=0a3a5857&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports